import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { notification, modal } from 'redux/modules/app'
import { revise as reviseApi } from 'redux/modules/api/combineDashboard'

function decorator() {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        revise: get(api, 'dashboard.revise')
      }),
      {
        ...reviseApi,
        notification,
        modal,
        push
      }
    )
    class apiRevise extends Component {
      static propTypes = {
        getActivitiesAssessment: PropTypes.func.isRequired,
        getActivitiesApproval: PropTypes.func.isRequired,
        getActivitiesSignOff: PropTypes.func.isRequired,
        getRpAssessment: PropTypes.func.isRequired,
        getRpApproval: PropTypes.func.isRequired,
        getRpSignOff: PropTypes.func.isRequired,
        getAjAssessment: PropTypes.func,
        getAjRequestAssessment: PropTypes.func,
        getActivityRequestAssessment: PropTypes.func,
        getRpRequestAssessment: PropTypes.func,
        getAjApproval: PropTypes.func,
        getAjSignOff: PropTypes.func,
        getPTSignOff: PropTypes.func,
        removeAssessments: PropTypes.func
      }

      handleGetActivitiesAssessment = (awardId, actionId) =>
        this.props.getActivitiesAssessment(awardId, actionId)

      handleGetActivitiesSignOff = (awardId, actionId) =>
        this.props.getActivitiesSignOff(awardId, actionId)

      handleGetActivitiesApproval = (awardId, actionId) =>
        this.props.getActivitiesApproval(awardId, actionId)

      handleGetRpAssessment = (awardId, actionId) =>
        this.props.getRpAssessment(awardId, actionId)

      handleGetRpSignOff = (awardId, actionId) =>
        this.props.getRpSignOff(awardId, actionId)

      handleGetRpApproval = (awardId, actionId) =>
        this.props.getRpApproval(awardId, actionId)

      handleGetAjAssessment = (awardId, actionId) =>
        this.props.getAjAssessment(awardId, actionId)

      handleGetAjRequestAssessment = (awardId, actionId) =>
        this.props.getAjRequestAssessment(awardId, actionId)

      handleGetAjSignOff = (awardId, actionId) =>
        this.props.getAjSignOff(awardId, actionId)

      handleGetAjApproval = (awardId, actionId) =>
        this.props.getAjApproval(awardId, actionId)

      handleGetPTSignOff = (awardId, actionId) =>
        this.props.getPTSignOff(awardId, actionId)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onGetActivitiesAssessment={this.handleGetActivitiesAssessment}
            onGetActivitiesApproval={this.handleGetActivitiesApproval}
            onGetActivitiesSignOff={this.handleGetActivitiesSignOff}
            onGetRpAssessment={this.handleGetRpAssessment}
            onGetRpApproval={this.handleGetRpApproval}
            onGetRpSignOff={this.handleGetRpSignOff}
            onGetAjAssessment={this.handleGetAjAssessment}
            getAjRequestAssessment={this.handleGetAjRequestAssessment}
            getActivityRequestAssessment={
              this.props.getActivityRequestAssessment
            }
            getRpRequestAssessment={this.props.getRpRequestAssessment}
            onGetAjApproval={this.handleGetAjApproval}
            onGetAjSignOff={this.handleGetAjSignOff}
            onGetPTSignOff={this.handleGetPTSignOff}
            removeAssessments={this.props.removeAssessments}
          />
        )
      }
    }
    return apiRevise
  }
}

export default decorator
